module.exports = __webpack_public_path__ + "img/carousel-1-slide-2.164d09a0.webp";